import { memo } from 'react';
import { Box, Button, Modal } from '@amzn/awsui-components-core';

import { useAttachmentsGuidelineLinkViewModel } from './AttachmentsGuidelineLinkViewModel';

export const AttachmentsGuidelineLink = memo(function AttachmentsGuidelineLink() {
  const vm = useAttachmentsGuidelineLinkViewModel();

  return (
    <>
      <Button
        variant="link"
        iconName="download"
        loading={vm.isLoading}
        onClick={vm.openGuidelinesDeck}
      >
        How to build architecture diagrams
      </Button>
      {vm.errorMessage && (
        <Modal
          visible
          header="Could not open guidelines"
          onDismiss={vm.dismissError}
          closeAriaLabel="Close modal"
          footer={
            <Box float="right">
              <Button variant="primary" onClick={vm.dismissError}>
                Dismiss
              </Button>
            </Box>
          }
        >
          {vm.errorMessage}
        </Modal>
      )}
    </>
  );
});
